"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

// Toggle state is select state with 2 assumptions
// - options is [false, true]
// - allowEmpty doesn't make sense, it's always false
function filterProps(props) {
  var value = props.value,
      defaultValue = props.defaultValue,
      onChange = props.onChange,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["value", "defaultValue", "onChange"]);
  return restProps;
}

function useToggleState(props) {
  var value = props.value,
      defaultValue = props.defaultValue,
      onChange = props.onChange; // UNCONTROLLED ONLY IF: value === "undefined"

  var isControlled = typeof value !== "undefined";

  var _useState = (0, _react.useState)(!!defaultValue),
      internalValue = _useState[0],
      setInternalValue = _useState[1];

  var currentValue = isControlled ? !!value : internalValue;

  var setValue = function setValue(newVal) {
    newVal = !!newVal;

    if (newVal === currentValue) {
      return;
    }

    if (!isControlled) {
      setInternalValue(newVal);
    }

    if (onChange) {
      onChange(newVal);
    }
  };

  return {
    value: currentValue,
    setValue: setValue,
    reset: function reset() {
      setValue(false);
    }
  };
}

useToggleState.filterProps = filterProps;
var _default = useToggleState;
exports["default"] = _default;